export default {
  methods: {
    // validates against 'anystring@anystring.anystring', enforces RFC2822 char limit
    isValidEmail: (email) => email.length <= 255 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }
};
